<mat-card class="install">
  <mat-card-header>
    <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.INSTALLATION' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
      <mat-tab label="{{ 'INBOX.WEBCHAT.SETTINGS.WEBSITE_INSTALLATION' | translate }}">
        <div class="tab-content">
          <div class="instructions">
            {{ 'INBOX.WEBCHAT.SETTINGS.INSTALL_INSTRUCTIONS' | translate }}
            <a style="white-space: nowrap" (click)="openInstallDetails()">
              {{ 'INBOX.WEBCHAT.SETTINGS.INSTALL_INSTRUCTIONS_READ_MORE' | translate }}
            </a>
          </div>

          <glxy-code-sample [title]="'Javascript'" [copyLabel]="'INBOX.COMMON.ACTION_LABELS.COPY'">
            {{ codeSnippet() }}
          </glxy-code-sample>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'INBOX.WEBCHAT.SETTINGS.GTM_TITLE' | translate }}">
        <div class="tab-content">
          <div class="instructions">
            <p>{{ 'INBOX.WEBCHAT.SETTINGS.GTM_DESCRIPTION' | translate }}</p>
          </div>

          <glxy-code-sample [title]="'Javascript'" [copyLabel]="'INBOX.COMMON.ACTION_LABELS.COPY'">
            {{ gtmCodeSnippet() }}
          </glxy-code-sample>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'INBOX.WEBCHAT.SETTINGS.WORD_PRESS_INSTALLATION' | translate }}">
        <div class="tab-content">
          <div class="instructions">
            <p>
              {{ 'INBOX.WEBCHAT.SETTINGS.WORD_PRESS_INSTALL_INSTRUCTIONS' | translate }}
            </p>
            <p [innerHTML]="'INBOX.WEBCHAT.SETTINGS.WORD_PRESS_INSTALL_INSTRUCTIONS_DETAILS' | translate"></p>
          </div>

          <div>
            <button mat-flat-button color="primary" (click)="downloadPlugin()">
              {{ 'INBOX.WEBCHAT.SETTINGS.WORD_PRESS_DOWNLOAD' | translate }}
            </button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'INBOX.WEBCHAT.SETTINGS.GO_DADDY_TITLE' | translate }}">
        <div class="tab-content">
          <div class="instructions">
            <p>{{ 'INBOX.WEBCHAT.SETTINGS.GO_DADDY_DESCRIPTION' | translate }}</p>
          </div>

          <glxy-code-sample [title]="'Javascript'" [copyLabel]="'INBOX.COMMON.ACTION_LABELS.COPY'">
            {{ godaddySnippet() }}
          </glxy-code-sample>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
